import DoubleLeftIcon from '../../Assets/images/svg/dar_collection_dashboard_dso_double_left.svg';
import DoubleRightIcon from '../../Assets/images/svg/dar_collection_dashboard_dso_double_right.svg';
import PropTypes from 'prop-types';
import { Calendar } from 'primereact/calendar';
import './YearPicker.scss';
import 'primeicons/primeicons.css';

const YearPicker = ({
  formatYear,
  visible,
  onVisibleChange,
  value,
  onChange,
  inputClassName,
  containerClassName,
}) => {
  return (
    <div className={containerClassName}>
      <Calendar
        inputClassName={inputClassName}
        view="year"
        value={value}
        onChange={onChange}
        formatDateTime={formatYear}
        prevIcon={CustomPrevIcon}
        nextIcon={CustomNextIcon}
        visible={visible}
        onVisibleChange={onVisibleChange}
        placeholder='Select'
        pt={{
          panel: { className: 'dso-date-picker-panel' },
          header: { className: 'dso-date-picker-panel-header' },
          previousButton: { className: 'dso-panel-header-buttons' },
          nextButton: { className: 'dso-panel-header-buttons' },
        }}
        readOnlyInput
      />
      <button className="calendar-dropdown-icon" onClick={onVisibleChange}>
        <i className="pi pi-angle-down"></i>
      </button>
    </div>
  );
};

const CustomPrevIcon = (options) => {
  return (
    <span {...options.iconProps}>
      <img src={DoubleLeftIcon} alt="prev-icon" />
    </span>
  );
};

const CustomNextIcon = (options) => {
  return (
    <span {...options.iconProps}>
      <img src={DoubleRightIcon} alt="next-icon" />
    </span>
  );
};

YearPicker.propTypes = {
  visible: PropTypes.bool.isRequired,
  onVisibleChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  inputClassName: PropTypes.string.isRequired,
  containerClassName: PropTypes.string,
  formatYear: PropTypes.func.isRequired,
};

export default YearPicker;
